import React from 'react';
import styles from './ScrollHint.module.css';

const ScrollHint = () => (
  <div className={styles.scrollHint} aria-hidden="true">
    <span className={styles.mouse}>
      <span className={styles.wheel} />
    </span>
    <span className={styles.text}>Листай дальше, чтобы узнать больше</span>
  </div>
);

export default ScrollHint;
